"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const polished_1 = require("polished");
exports.PageHeaderButtons = styled_components_1.default.span `
  margin-left: 20px;
`;
exports.PageUserButton = styled_components_1.default(react_router_dom_1.Link) `
  font-size: 12pt;
  color: #fff;
  padding: 7px;

  &:hover {
    color: ${props => polished_1.lighten(0.3, props.theme.colors.gray)};
  }
`;
